import React, { useState } from 'react'
import icon from '../../../assets/shareholdersIcon.png'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import client from '../../../api/client'
import showToast from '../../../components/CustomToast/toastHelper'
import { Spinner } from 'flowbite-react'
interface LogRefundProps{
    close :() =>void,
    onComplete:() =>void
}
const LogSingleRefund = ({close, onComplete}:LogRefundProps) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [inputs, setInputs] = useState({
        reference:'',
        reason:'',
        status:'',
        amount:'',
        message:''
    })

    const dataToSend:any = []

    const logRefund =async() =>{
        setLoading(true)
        const data ={
            
            transactionReference: inputs.reference,
            amount: Number(inputs.amount),
            reason:inputs.reason,
            message:inputs.message,
            status:inputs.status
        }

        const payload =[...dataToSend, data]
        
        try {
            const response = await client.post('/subsidiary/dashboard/refund',payload);
            const message = response?.data?.message;
            showToast(message,"success")
            onComplete();
            close()
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
        finally{
            setLoading(false)
        }
    }
    return (
        <div>
            <div className='h-full bg-green-50 p-4 '>
                <img src={icon} alt="icon" />
                <p className='font-semibold py-2'>Refunds</p>
                <p className='text-sm'>Kindly fill in the information needed</p>
            </div>
            <div className='my-4'>
                <div className='my-2'>
                    <CustomInput type='number' label='Amount' name='amount' value={inputs.amount} onChange={e =>setInputs({...inputs,amount:e.target.value})} />
                </div>
                <div className='my-2'>
                    <CustomInput label='Transaction Reference' name='transRef' value={inputs.reference} onChange={e =>setInputs({...inputs,reference:e.target.value})} />
                </div>
                <div className='my-2'>
                    <CustomInput label='Reason for refund' name='reason' value={inputs.reason} onChange={e =>setInputs({...inputs,reason:e.target.value})}/>
                </div>
            </div>
            <div className='flex gap-3'>
                <button className='border w-1/4 py-3 px-6 rounded-lg text-lg font-semibold' onClick={()=>close()} >
                    Cancel
                </button>
                <button className='border w-3/4 py-3 px-6 rounded-lg bg-custom-button-green text-lg font-semibold hover:text-white' onClick={()=>logRefund()}>
                    {loading ? <Spinner size='sm'/> : 'Log a refund'}
                </button>
            </div>
        </div>
    )
}

export default LogSingleRefund
